import { useState } from 'react';

import { Box, Button, TextField, Typography } from '@material-ui/core';

import {
  FormFieldsBox,
  FormSubmitButtons,
  PageLayout,
  useAlert,
  useAuth,
  useAuthFactory,
} from '@spotify/confidence-core-react';

export const DebugPage = () => {
  const alert = useAlert();
  const auth = useAuth();
  const { overrideToken, setOverrideToken } = useAuthFactory();
  const [authToken, setAuthToken] = useState(overrideToken ?? '');

  return (
    <PageLayout title="Debug">
      <Box display="flex" flexDirection="column" gridGap={32}>
        <Box>
          <Typography variant="h4">Auth token</Typography>
          <Typography color="textSecondary" paragraph>
            Copy the current auth token to the clipboard.
          </Typography>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            onClick={() => {
              if (overrideToken) {
                navigator.clipboard.writeText(overrideToken);
              } else {
                auth
                  .getAccessTokenSilently()
                  .then(token => navigator.clipboard.writeText(token));
              }
              alert.post({
                message: 'Auth token copied to clipboard',
                severity: 'success',
                display: 'transient',
              });
            }}
          >
            Copy auth token
          </Button>
        </Box>
        <Box>
          <Typography variant="h4">Override auth token</Typography>
          <Typography color="textSecondary" paragraph>
            Override the auth token for the current session, this will be used
            for all requests until the override is cleared.
          </Typography>
          <FormFieldsBox spacing={2}>
            <TextField
              name="name"
              variant="outlined"
              placeholder="Override auth token"
              required
              label="Override auth token"
              value={authToken}
              onChange={e => setAuthToken(e.target.value)}
              fullWidth
              autoFocus
              autoComplete="off"
              multiline
            />
            <FormSubmitButtons
              onCancel={() => setOverrideToken(undefined)}
              onSubmit={() => setOverrideToken(authToken)}
              cancelLabel="Clear override"
              label="Override"
            />
          </FormFieldsBox>
        </Box>
      </Box>
    </PageLayout>
  );
};
